import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableEventAdmissionsComponent from '../components/TableEventAdmissionsComponent';
import EventSalonTablesComponent from '../components/EventSalonTablesComponent';
import EventIncludedCard from '../components/EventIncludedCard';
import ModalSellEventComponent from '../components/ModalSellEventComponent';
import { validateSession } from '../utils/functions';
import { isAdminOrManager } from '../utils/enums';

var config = process.env;

class EventAdmissionsPage extends Component {
    constructor() {
        super();
        // `attendees` viaja HERMANO de `event` en la respuesta del detalle, no adentro.
        this.state = { checked: false, role: 0, id: null, event: null, attendees: null };
        this.tableRef = React.createRef();
        this.sellRef = React.createRef();
    }

    // «Venta presencial» abre el diálogo por Bootstrap (data-toggle); esto sólo le avisa que se
    // abre, para que un evento sólo mostrador arranque con lo que le falta vender.
    onOpenSell = () => {
        if (this.sellRef.current) {
            this.sellRef.current.alAbrir();
        }
    }

    async componentDidMount() {
        const role = await validateSession();
        const params = new URLSearchParams(this.props.location.search);
        const id = params.get('id');
        this.setState({ checked: true, role, id });
        this.fetchEvent(id);
    }

    fetchEvent = (id) => {
        const request = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `manage-events/${id}`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    // ENI-116: leer el mensaje de negocio anidado si viene (data.data.message), si no el genérico
                    alert((data.data && data.data.message) || data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    // El backend devuelve { data: { event, attendees } }; la actividad de la
                    // jornada va adentro y plana (`event.activity`).
                    this.setState({ event: data.data.event, attendees: data.data.attendees || null });
                }
            })
            .catch((error) => {
                console.error('No se pudo cargar el evento:', error);
                alert('Error de conexión');
            });
    }

    onSold = () => {
        if (this.tableRef.current) {
            this.tableRef.current.refresh();
        }
        // Los números de la card de mesas (Anotados, cupo) salen del detalle del evento, no de
        // la tabla: sin releerlo quedaban viejos hasta recargar la pantalla.
        this.fetchEvent(this.state.id);
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        const event = this.state.event;
        const ticketTypes = event ? (event.ticketTypes || []) : [];
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={33} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                {/* ENI-160: el header (subtítulo dinámico con el nombre del evento) necesita
                                    crecer; si no, queda en un col-sm-4 al 33% y el título se ve apretado/roto. */}
                                <div className="flex-grow-1 mr-3">
                                    <HeaderComponent title="Eventos" subtitle={event ? `Asistentes — ${event.title}` : 'Asistentes'} />
                                </div>
                                {/* Sólo si el backend la aceptaría: en un evento que ya ocurrió (o en un
                                    borrador) el botón llevaba a un formulario que siempre rechazaba.
                                    En su lugar, el motivo. Un backend viejo no manda el campo:
                                    `!== false` deja el botón como siempre. */}
                                {isAdminOrManager(this.state.role) && (event && event.canSellPresencial === false ? (
                                    <small className="text-muted text-nowrap">{event.presencialBlockReason || 'No se venden más entradas'}</small>
                                ) : (
                                    <button type="button" className="btn btn-accent text-nowrap" data-toggle="modal" data-target="#modal-sell-event" onClick={this.onOpenSell}>
                                        Venta presencial
                                    </button>
                                ))}
                            </div>
                            {/* `included` es lo que pactó el evento: de ahí sale que «Marcar ingreso»
                                pregunte antes y que «Sentar a todos» esté también arriba de la lista. */}
                            {this.state.id && (
                                <TableEventAdmissionsComponent
                                    ref={this.tableRef}
                                    eventId={this.state.id}
                                    activity={this.state.event && this.state.event.activity}
                                    included={this.state.event && this.state.event.included}
                                    onActivityChange={() => this.fetchEvent(this.state.id)}
                                />
                            )}
                            {/* FR-022: el mismo bloque de mesas que la pantalla de edición, acá
                                abajo — en la noche de la jornada, la pantalla que está abierta
                                en el mostrador es ésta, no la de edición. */}
                            <EventSalonTablesComponent
                                event={this.state.event}
                                attendees={this.state.attendees}
                                onRefresh={() => this.fetchEvent(this.state.id)}
                            />
                            {/* Sólo se dibuja si el evento declara qué incluye. Va acá por lo
                                mismo que las mesas: es la pantalla abierta la noche del evento. */}
                            <EventIncludedCard event={this.state.event} />
                        </div>
                    </main>
                </div>
                {/* Cupo y vendidas salen del detalle, que se relee después de cada venta: con
                    eso un evento sólo mostrador arranca con lo que le falta vender. */}
                {this.state.id && (
                    <ModalSellEventComponent
                        ref={this.sellRef}
                        eventId={this.state.id}
                        ticketTypes={ticketTypes}
                        eventIsFree={!!(event && event.is_free)}
                        eventStartsAt={event && event.starts_at}
                        counterOnly={!!(event && Number(event.counter_only))}
                        capacity={event ? event.capacity : null}
                        sold={event ? event.sold : 0}
                        onSold={this.onSold}
                    />
                )}
            </div>
        );
    }
}

export default EventAdmissionsPage;
